var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursor-pointer text-xl rounded-lg w-7 text-center",class:{
    'bg-red-500 text-white': !_vm.value,
    'bg-green-500 text-white': _vm.value,
  },on:{"click":function($event){return _vm.$emit('input',!_vm.value)}}},[(_vm.value)?[_vm._v("✓")]:[_vm._v("✗")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }